import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { SelectField } from "../../../components/Form/SelectField";
import style from "./Detail.module.scss";
import { FaAmbulance } from "react-icons/fa";
import { IoMdCalendar, IoIosArrowDropleftCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProductCard from "../../../components/InfoCard/ProductCard";
import QuipCard from "../../../components/InfoCard/QuipCard";
import { hospitalList } from "../../../redux/orders/actions/orders.actions";
import { Formik } from "formik";
import { Button } from "@mui/material";
import { saveHospitalDetails } from "../../../redux/new-order/actions/new-orders.actions";
import { ConfirmationModal } from "../../../components/Modal/ConfirmationModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GiSensuousness } from "react-icons/gi";
import Sensitive from "../../../components/modalInstruction/Sensitive";
import { startOfWeek, addDays, format, set } from "date-fns";
import { RiErrorWarningFill } from "react-icons/ri";
import { hospitalAlert } from "../../../components/NotificationToast";
import axiosClient from "../../../service/axios";

const Detail = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [openModal, setopenModal] = useState(false);
  // const [startDate, setStartDate] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date());
  const [sensitive, setSensitive] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedPickupDate, setSelectedPickupDate] = useState("");
  const [showFeeModal, setShowFeeModal] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [check, setCheck] = useState([]);
  // console.log("check", check);
  // console.log("selectedHospital", selectedHospital);
  useEffect(() => {
    const fetchHospitals = async () => {
      try {
        const response = await axiosClient.get("/lite/v2/api/order/noops");
        setCheck(response?.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchHospitals();
  }, []);

  const today = new Date();

  // Get this week's Thursday and Friday
  const thisThursday = addDays(startOfWeek(today, { weekStartsOn: 1 }), 3); // Monday + 3 days = Thursday
  const thisFriday = addDays(startOfWeek(today, { weekStartsOn: 1 }), 4); // Monday + 4 days = Friday

  // Get delivery dates (next week's Monday and Tuesday)
  const nextMonday = addDays(thisThursday, 4); // Thursday + 4 = Monday
  const nextTuesday = addDays(thisFriday, 4); // Friday + 4 = Tuesday

  // Format helper (e.g. "Thursday 4th", "Delivery Monday 8th")
  const formatDateLabel = (date, prefix = "") =>
    `${prefix ? prefix + ": " : ""}${format(date, "dd/MM/yyyy")}`;

  // const [value, onChange] = useState();

  useEffect(() => {
    if (!orderType?.cardText) {
      navigate("/place-order");
    }
  }, []);

  const { orderType } = useSelector((state) => state.newOrderReducer);

  const colors = () => {
    if (orderType?.cardText === "BLOOD") return "#B70303";
    if (orderType?.cardText === "OXYGEN") return "#0779F7";
    if (orderType?.cardText === "STOCKBANK") return "#066304";
    if (orderType?.cardText === "QUIP") return "#DA621B";
    return "#B70303";
  };

  const [hospitalDropDown, setHospitalDropDown] = useState();

  useEffect(() => {
    dispatch(hospitalList()).then((response) => {
      let options = response.data
        .sort((a, b) => a.label - b.label)
        .map((hosp) => ({
          label: `${hosp.Name} (${hosp.State}-${hosp.City})`,
          receivables: hosp.Receivables,
          value: hosp.Hospital_ID,
          sensitive: hosp.sensitive_cus,
          state: hosp.State,
        }));
      setHospitalDropDown(options);
    });
  }, [dispatch]);

  return (
    <>
     <div className={style.greeting}>
        <p>
          <span style={{ color: "#b70303", fontWeight: "bold" }}>
            LifeBank CSA Script |{" "}
          </span>
          Alright Ma/Sir. Is this an emergency/urgent or a scheduled order?
        </p>
      </div>
      <div className={style.container}>
        <Row>
          <Col md={1}>
            <IoIosArrowDropleftCircle
              size={50}
              color={colors()}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
          </Col>
          <Col md={10}>
            <h3 className={style.header} style={{ color: colors() }}>
              hospital detail
            </h3>
            <h4 className={style.requestHeader1} style={{ color: colors() }}>
              select hospital <span style={{ color: "red", fontSize: "12px" }}>(You must select hospital before proceeding)</span>
            </h4>
            <Formik
              initialValues={{
                hospital: null,
                hospitalId: "",
                receivables: "",
                requestType: "Emergency",
              }}
              validate={(values) => {
                const errors = {};
                if (!values.hospital) {
                  errors.hospital = "This field is mandatory";
                }
                return errors;
              }}
              onSubmit={(values, actions) => {
                // values.hospital = values.hospital.value;
                localStorage.setItem(
                  "order_by",
                  JSON.stringify(values.hospital.value),
                );

                // dispatch(saveOrderType(values, actions));
                dispatch(saveHospitalDetails(values, actions));
                if (orderType?.cardText === "BLOOD") {
                  navigate("/place-order/blood-component");
                } else {
                  navigate("/place-order/order-type");
                }
              }}
            >
              {({
                handleChange,
                handleSubmit,
                isSubmitting,
                values,
                resetForm,
                setFieldValue,
                handleBlur,
                errors,
                touched,
              }) => (
                <form>
                  <div className={`${style.formInput} shadow-none`}>
                    <SelectField
                      className={style.input}
                      name="hospital"
                      options={hospitalDropDown}
                      onChange={(selected) => {
                        // console.log("Selected from dropdown:", selected);

                        const isBlocked = check?.some(
                          (hosp) =>
                            hosp?.toLowerCase() ===
                            selected?.state?.toLowerCase(),
                        );

                        // Check hospital state
                        if (isBlocked) {
                          hospitalAlert();
                          setFieldValue("hospital", null);
                          setSelectedHospital(null);
                          return; 
                        }

                        // Otherwise, proceed normally
                        setFieldValue("hospital", selected);
                        setSelectedHospital(selected);
                      }}
                      value={values?.hospital}
                      placeholder="Find a hospital here"
                      onBlur={handleBlur}
                    />

                    {values.hospital?.sensitive ? (
                      <div onClick={() => setSensitive(true)}>
                        <GiSensuousness
                          size={40}
                          className={style.sensitiveIcon}
                          style={{
                            color: colors(),
                            cursor: "pointer",
                            marginTop: "10px",
                          }}
                        />
                      </div>
                    ) : (
                      <div></div>
                    )}

                    {errors.hospital && touched.hospital ? (
                      <p className="text-danger mt-1 mx-2">{errors.hospital}</p>
                    ) : null}
                  </div>

                  {orderType?.cardText === "stockbank".toUpperCase() &&
                  orderType?.cardText === "quip".toUpperCase() ? (
                    <h4
                      className={style.requestHeader}
                      style={{ color: colors() }}
                    >
                      select products
                    </h4>
                  ) : (
                    orderType?.cardText === "blood".toUpperCase() && (
                      <h4
                        className={style.requestHeader}
                        style={{ color: colors() }}
                      >
                        select request type
                      </h4>
                    )
                  )}
                  {orderType?.cardText === "stockbank".toUpperCase() &&
                  orderType?.cardText === "quip".toUpperCase() ? (
                    ""
                  ) : (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                        }}
                      >
                        <Button
                          type="submit"
                          name="Emergency"
                          onClick={handleSubmit}
                          disabled={isSubmitting || !values.hospital}
                          className={style.request}
                          style={{
                            background: values.hospital ? colors() : "#C0C0C0",
                            cursor: values.hospital ? "pointer" : "not-allowed",
                          }}
                        >
                          <FaAmbulance color="white" size={100} />
                          <p className={style.text}>EMERGENCY</p>
                        </Button>

                        {orderType?.cardText === "blood".toUpperCase() && (
                          <Button
                            type="submit"
                            name="Urgent"
                            onClick={() => {
                              if (!values.hospital) return;
                              setFieldValue("requestType", "Urgent");
                              handleSubmit();
                            }}
                            disabled={isSubmitting || !values.hospital}
                            className={style.request}
                            style={{
                              background: values.hospital
                                ? colors()
                                : "#C0C0C0",
                              cursor: values.hospital
                                ? "pointer"
                                : "not-allowed",
                            }}
                          >
                            <FaAmbulance color="white" size={100} />
                            <p className={style.text}>URGENT</p>
                          </Button>
                        )}
                      </div>

                      {orderType?.cardText === "blood".toUpperCase() && (
                        <div
                          name="Scheduled"
                          onClick={() => {
                            if (!values.hospital) {
                              hospitalAlert("Please select a hospital first");
                              return;
                            }
                            setopenModal(true);
                          }}
                          className={style.request}
                          style={{
                            background: values.hospital ? colors() : "#C0C0C0",
                            cursor: values.hospital ? "pointer" : "not-allowed",
                            pointerEvents: values.hospital ? "auto" : "none",
                          }}
                        >
                          <IoMdCalendar color="white" size={100} />
                          <p className={style.text}>SCHEDULED</p>
                        </div>
                      )}

                      {orderType?.cardText === "oxygen".toUpperCase() && (
                        <div
                          name="Scheduled"
                          onClick={() => {
                            if (!values.hospital) {
                              hospitalAlert("Please select a hospital first");
                              return;
                            }
                            setopenModal(true);
                          }}
                          className={style.request}
                          style={{
                            background: values.hospital ? colors() : "#C0C0C0",
                            cursor: values.hospital ? "pointer" : "not-allowed",
                            pointerEvents: values.hospital ? "auto" : "none",
                          }}
                        >
                          <IoMdCalendar color="white" size={100} />
                          <p className={style.text}>SCHEDULED</p>
                        </div>
                      )}
                    </div>
                  )}
                  {orderType?.cardText === "stockbank".toUpperCase() && (
                    <ProductCard />
                  )}

                  {orderType?.cardText === "quip".toUpperCase() && <QuipCard />}

                  <Sensitive
                    value={values.hospital?.sensitive}
                    sensitive={sensitive}
                    setSensitive={setSensitive}
                  />
                </form>
              )}
            </Formik>
          </Col>
        </Row>

        {/* DIALOG MODAL */}
        <ConfirmationModal
          open={openModal}
          bgcolor="background.paper"
          width="40vw"
          handleClose={() => setopenModal(false)}
          closemodal={() => setopenModal(false)}
          selectedHospital={selectedHospital}
          instruction={
            <div className={style.schedule}>
              {orderType?.cardText === "oxygen".toUpperCase() ? (
                <Formik
                  initialValues={{
                    hospital: selectedHospital || null,
                    hospitalId: "",
                    date: "",
                    time: "",
                    requestType: "Scheduled",
                  }}
                  // validate={(values) => {
                  //   const errors = {};
                  //   if (!values.time || !values.hospital || !values.date) {
                  //     errors.time = "All fields are mandatory";
                  //   }
                  //   return errors;
                  // }}
                  onSubmit={(values, actions) => {
                    values.hospital = selectedHospital;
                    values.date = startDate || selectedPickupDate; // support either path
                    values.time = selectedTime;

                    const isRegularDate =
                      selectedPickupDate === formatDateLabel(thisThursday) ||
                      selectedPickupDate === formatDateLabel(thisFriday);

                    if (!isRegularDate && startDate) {
                      // Show confirmation modal if user picked custom date
                      setFormValues({ values, actions });
                      setShowFeeModal(true);
                      setopenModal(false);
                      return;
                    }

                    dispatch(saveHospitalDetails(values, actions));
                    if (orderType?.cardText === "BLOOD") {
                      navigate("/place-order/blood-component");
                    } else {
                      navigate("/place-order/extra-cylinder");
                    }
                  }}
                >
                  {({
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    values,
                    resetForm,
                    setFieldValue,
                    handleBlur,
                    errors,
                    touched,
                  }) => (
                    <form>
                      {/* Time selection */}
                      <div className={style.timeSelector}>
                        <p>Select Time</p>
                        <div className="flex gap-3 mt-2 flex-wrap">
                          {[
                            "12:00 PM",
                            "2:00 PM",
                            "4:00 PM",
                            "6:00 PM",
                            "8:00 PM",
                          ].map((time) => (
                            <button
                              type="button"
                              key={time}
                              className={`px-4 py-2 rounded-md border-0 ${
                                selectedTime === time
                                  ? "text-white"
                                  : "text-black bg-white"
                              }`}
                              style={
                                selectedTime === time
                                  ? {
                                      backgroundColor: colors(),
                                      borderRadius: "50px",
                                    }
                                  : {}
                              }
                              onClick={() => setSelectedTime(time)}
                            >
                              {time}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Pickup date selection */}
                      <div className="mt-5">
                        <p>Available dates for pickup</p>
                        <div className="flex gap-3 mt-2">
                          {[
                            {
                              label: formatDateLabel(thisThursday),
                              delivery: formatDateLabel(nextMonday, "Delivery"),
                              value: thisThursday,
                              deliveryDate: nextMonday, //  actual delivery date
                            },
                            {
                              label: formatDateLabel(thisFriday),
                              delivery: formatDateLabel(
                                nextTuesday,
                                "Delivery",
                              ),
                              value: thisFriday,
                              deliveryDate: nextTuesday, //  actual delivery date
                            },
                          ].map((item) => (
                            <button
                              type="button"
                              key={item.label}
                              className={`p-3 rounded-md border-0 ${
                                selectedPickupDate === item.label
                                  ? "text-white"
                                  : "bg-white text-black"
                              }`}
                              style={
                                selectedPickupDate === item.label
                                  ? {
                                      backgroundColor: colors(),
                                      borderRadius: "10px",
                                    }
                                  : {}
                              }
                              onClick={() => {
                                setSelectedPickupDate(item.label);

                                //  Automatically highlight delivery date in convenient date section
                                // setStartDate(item.deliveryDate);
                              }}
                            >
                              <p>{item.label}</p>
                              <small>{item.delivery}</small>
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Alternative date picker */}
                      <div className="mt-4">
                        <p className="text-sm text-gray-600">
                          Switch to emergency delivery? Enter a convenient
                          date:
                        </p>
                        <div className="flex gap-2 mt-2">
                          {[...Array(7)].map((_, i) => {
                            const altDate = new Date();
                            altDate.setDate(altDate.getDate() + i);
                            return (
                              <button
                                type="button"
                                key={i}
                                className={`px-3 py-2 rounded-md border-0 ${
                                  startDate &&
                                  altDate.toDateString() ===
                                    startDate.toDateString()
                                    ? "bg-blue-600 text-white"
                                    : "bg-white"
                                }`}
                                style={
                                  startDate &&
                                  altDate.toDateString() ===
                                    startDate.toDateString()
                                    ? {
                                        backgroundColor: colors(),
                                        borderRadius: "10px",
                                      }
                                    : {}
                                }
                                onClick={() => {
                                  setStartDate(altDate);
                                  setSelectedPickupDate(null); // reset fixed date
                                }}
                              >
                                {format(altDate, "dd/MM/yyyy")}
                              </button>
                            );
                          })}
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                          <RiErrorWarningFill /> Kindly note that deliveries are
                          done 4 days from the scheduled date, and scheduling
                          outside the available dates will incur a cylinder
                          exchange fee.
                        </p>
                      </div>

                      {/* Proceed button */}
                      <Button
                        type="submit"
                        name="Scheduled"
                        onClick={handleSubmit}
                        disabled={
                          isSubmitting ||
                          !values.hospital ||
                          (!selectedPickupDate && !startDate) ||
                          !selectedTime
                        }
                        className={style.btn}
                        style={{
                          width: "100%",
                          background:
                            isSubmitting ||
                            !values.hospital ||
                            (!selectedPickupDate && !startDate) ||
                            !selectedTime
                              ? "#C0C0C0" // grey color for disabled
                              : colors(), // active color
                          color: "white",
                          marginTop: "20px",
                          fontWeight: 600,
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      >
                        Proceed
                      </Button>
                    </form>
                  )}
                </Formik>
              ) : (
                <Formik
                  initialValues={{
                    hospital: selectedHospital || null,
                    hospitalId: "",
                    date: "",
                    time: "",
                    requestType: "Scheduled",
                  }}
                  // validate={(values) => {
                  //   const errors = {};
                  //   if (!values.time || !values.hospital || !values.date) {
                  //     errors.time = "All fields are mandatory";
                  //   }
                  //   return errors;
                  // }}
                  onSubmit={(values, actions) => {
                    values.hospital = selectedHospital;
                    values.date = startDate;
                    values.time = startTime;

                    dispatch(saveHospitalDetails(values, actions));
                    if (orderType?.cardText === "BLOOD") {
                      navigate("/place-order/blood-component");
                    } else {
                      navigate("/place-order/order-type");
                    }
                  }}
                >
                  {({
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    values,
                    resetForm,
                    setFieldValue,
                    handleBlur,
                    errors,
                    touched,
                  }) => (
                    <form>
                      {/* <p className="text-danger mt-1 mx-2 mb-3">
                        All fields are required
                      </p>

                      <div className={`${style.formInput} shadow-none`}>
                        <SelectField
                          className={style.input}
                          name="hospital"
                          options={hospitalDropDown}
                          onChange={setFieldValue}
                          value={values?.hospital}
                          placeholder="Find a hospital here"
                          onBlur={handleBlur}
                        />
                        {errors.hospital && touched.hospital ? (
                      <p className="text-danger mt-1 mx-2">{errors.hospital}</p>
                    ) : null}
                      </div> */}
                      <div className={style.picker}>
                        <div className={style.inner}>
                          <p>Select a Date</p>
                          {/* <DayJS>2000-01-31T12:59-0500</DayJS> */}
                          <DatePicker
                            className={`${style.datePicker}`}
                            selected={startDate}
                            name="date"
                            dateFormat="dd/MM/yyyy"
                            value={startDate}
                            minDate={new Date()}
                            onChange={(date) => setStartDate(date)}
                          />
                          {/* {errors.date && touched.date ? (
                        <p className="text-danger mt-1 mx-2">{errors.date}</p>
                      ) : null} */}
                        </div>
                        <div className={style.inner}>
                          <p>Select Time</p>
                          {/* <TimePicker
                        onChange={onChange}
                        name="time"
                        value={value}
                      /> */}
                          <DatePicker
                            selected={startTime}
                            onChange={(time) => setStartTime(time)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={60}
                            name="time"
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                          />
                          {/* {errors.time && touched.time ? (
                        <p className="text-danger mt-1 mx-2">{errors.time}</p>
                      ) : null} */}
                        </div>
                      </div>

                      <Button
                        type="submit"
                        name="Scheduled"
                        onClick={handleSubmit}
                        disabled={isSubmitting || !values.hospital}
                        className={style.btn}
                        style={{
                          background: colors(),
                          color: "white",
                          marginTop: "20px",
                          fontWeight: 600,
                          fontSize: "18px",
                        }}
                      >
                        Proceed
                      </Button>
                    </form>
                  )}
                </Formik>
              )}
            </div>
          }
        />

        <ConfirmationModal
          open={showFeeModal}
          handleClose={() => setShowFeeModal(false)}
          closemodal={() => setShowFeeModal(false)}
          bgcolor="background.paper"
          width="30vw"
          instruction={
            <div
              style={{
                padding: "20px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h4 className="text-lg font-semibold text-center mb-4">
                <RiErrorWarningFill /> Pickup schedule outside regular dates
              </h4>
              <p className="text-center text-sm mb-5">
                Your cylinder pickup date is outside the regular dates of
                pickups and would incur a cylinder exchange fee of{" "}
                <strong>₦500</strong>. Would you like to proceed?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    setShowFeeModal(false);
                  }}
                >
                  No, change date.
                </Button>
                <Button
                  variant="contained"
                  style={{ backgroundColor: colors(), color: "white" }}
                  onClick={() => {
                    if (formValues) {
                      dispatch(
                        saveHospitalDetails(
                          formValues.values,
                          formValues.actions,
                        ),
                      );
                      setShowFeeModal(false);
                      navigate(
                        orderType?.cardText === "BLOOD"
                          ? "/place-order/blood-component"
                          : "/place-order/extra-cylinder",
                      );
                    }
                  }}
                >
                  Yes, Proceed.
                </Button>
              </div>
            </div>
          }
        />
      </div>
    </>
  );
};

export default Detail;
